import type {
  ChartSpec,
  ChartType,
  ChartDimension,
  ChartMetric,
} from "../../shared/src/protocol";

export const CHART_TYPES: ChartType[] = [
  "bar",
  "stackedBar",
  "line",
  "pie",
  "heatmap",
];

export const DIMENSIONS: ChartDimension[] = [
  "time",
  "region",
  "hospital",
  "unit",
  "triage",
  "trauma",
  "hourOfDay",
  "dayOfWeek",
];

export const BREAKDOWN_DIMENSIONS = DIMENSIONS.filter(
  (d) => d !== "trauma",
) as Exclude<ChartDimension, "trauma">[];

export const METRICS: ChartMetric[] = ["cases", "deaths", "mortalityPct"];

export const DEFAULT_SPEC: ChartSpec = {
  chartType: "bar",
  dimension: "time",
  metric: "cases",
};

export function encodeSpec(spec: ChartSpec): string {
  return [
    spec.chartType,
    spec.dimension,
    spec.breakdown ?? "",
    spec.metric,
  ].join(":");
}

export function decodeSpec(s: string | null): ChartSpec | null {
  if (!s) return null;
  const parts = s.split(":");
  if (parts.length !== 4) return null;
  const [ct, dim, br, m] = parts;
  if (!CHART_TYPES.includes(ct as ChartType)) return null;
  if (!DIMENSIONS.includes(dim as ChartDimension)) return null;
  if (!METRICS.includes(m as ChartMetric)) return null;
  if (br && !BREAKDOWN_DIMENSIONS.includes(br as Exclude<ChartDimension, "trauma">)) return null;
  return {
    chartType: ct as ChartType,
    dimension: dim as ChartDimension,
    breakdown: br ? (br as Exclude<ChartDimension, "trauma">) : undefined,
    metric: m as ChartMetric,
  };
}
